// extracted by mini-css-extract-plugin
export default {"title":"description_title__kPQVi","questionIcon":"description_questionIcon__0asIb","description":"description_description__LpaIm","section":"description_section__WQ7q1"};